import React, { useCallback, useEffect, useRef, useState } from "react";
import DOMPurify from "dompurify";
import { decodeEntities } from "@wordpress/html-entities";
import { AliasPopup, CheckoutButton } from ".";
import { Popup } from "./popup";

const { registerPaymentMethod } = window.wc.wcBlocksRegistry;
const { getSetting } = window.wc.wcSettings;

const settings = getSetting("spgw_credit_card_data", {});
const label = decodeEntities(settings.title || "");
const alias_manager = decodeEntities(settings.alias_manager);
const alias = alias_manager == "active";
const ContentComponent = (props) => {
  const { eventRegistration, emitResponse } = props;
  const { onPaymentSetup } = eventRegistration;
  const [scriptExecuted, setScriptExecuted] = useState(false);
  const { themeHtml, credit_params, libraryUrl, themeCssUrl, save_card_html} = settings;
  const inputValidationData = useRef({});
  const cleanHTML = DOMPurify.sanitize(themeHtml);
  const saveCardCleanHTML = DOMPurify.sanitize(save_card_html);
  const labels = {
    invalid: credit_params.invalid,
    empty: credit_params.empty,
    unsupported: credit_params.unsupported,
    expired: credit_params.expired,
  };

 
  useEffect(() => {
    const executeScript = async () => {
      const script = document.createElement("script");
      script.src = libraryUrl;
      script.async = true; // Optional: Set async to avoid blocking rendering
      script.onload = () => setScriptExecuted(true);
      document.head.appendChild(script);
    };

    const executeStyle = async () => {
      const style = document.createElement("link");
      style.href = themeCssUrl;
      style.rel = "stylesheet";
      document.head.appendChild(style);
    };

    executeScript();
    executeStyle();
    
  }, []);

  useEffect(() => {
    if (scriptExecuted && SaferpayFields) {
      initSaferPay();
      
    }
  }, [scriptExecuted]);

  const getStyledInput = useCallback(() => {
    let style_design;
    switch (credit_params.inline_style) {
      case "sample1":
        style_design = {
          ".form-control":
            " border: none; border-bottom: solid 1px #CFCFCF; border-radius: 0px; height: 100%",

          ".form-control.is-valid, .was-validated .form-control:valid":
            "border-color: #28a745;padding-right: calc(1.5em + .75rem); background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA4IDgnPjxwYXRoIGZpbGw9JyMyOGE3NDUnIGQ9J00yLjMgNi43M0wuNiA0LjUzYy0uNC0xLjA0LjQ2LTEuNCAxLjEtLjhsMS4xIDEuNCAzLjQtMy44Yy42LS42MyAxLjYtLjI3IDEuMi43bC00IDQuNmMtLjQzLjUtLjguNC0xLjEuMXonLz48L3N2Zz4=);background-repeat: no-repeat; background-position: 92% 50%; background-size: calc(.75em + .375rem) calc(.75em + .375rem);",

          ".form-control.is-invalid, .was-validated .form-control:invalid":
            "  border-color: #dc3545;    padding-right: calc(1.5em + .75rem);background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIGZpbGw9JyNkYzM1NDUnIHZpZXdCb3g9Jy0yIC0yIDcgNyc+PHBhdGggc3Ryb2tlPScjZGMzNTQ1JyBkPSdNMCAwbDMgM20wLTNMMCAzJy8+PGNpcmNsZSByPScuNScvPjxjaXJjbGUgY3g9JzMnIHI9Jy41Jy8+PGNpcmNsZSBjeT0nMycgcj0nLjUnLz48Y2lyY2xlIGN4PSczJyBjeT0nMycgcj0nLjUnLz48L3N2Zz4=);background-repeat: no-repeat;background-position: 98% 50%;    background-size: calc(.75em + .375rem) calc(.75em + .375rem);",

          ".form-control.is-valid.is-pristine":
            "background-image: inherit; border-color:#CFCFCF;",

          ".input-group .logo": "right: 2em;",
        };

        break;

      case "sample2":
        style_design = {
          ".form-control":
            " border: solid 1px #CFCFCF; border-radius: 8px; height: 100%",

          ".form-control.is-valid, .was-validated .form-control:valid":
            "border-color: #28a745;padding-right: calc(1.5em + .75rem); background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA4IDgnPjxwYXRoIGZpbGw9JyMyOGE3NDUnIGQ9J00yLjMgNi43M0wuNiA0LjUzYy0uNC0xLjA0LjQ2LTEuNCAxLjEtLjhsMS4xIDEuNCAzLjQtMy44Yy42LS42MyAxLjYtLjI3IDEuMi43bC00IDQuNmMtLjQzLjUtLjguNC0xLjEuMXonLz48L3N2Zz4=);background-repeat: no-repeat; background-position: 85% 50%; background-size: calc(.75em + .375rem) calc(.75em + .375rem);",

          ".form-control.is-invalid, .was-validated .form-control:invalid":
            "  border-color: #dc3545;    padding-right: calc(1.5em + .75rem);background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIGZpbGw9JyNkYzM1NDUnIHZpZXdCb3g9Jy0yIC0yIDcgNyc+PHBhdGggc3Ryb2tlPScjZGMzNTQ1JyBkPSdNMCAwbDMgM20wLTNMMCAzJy8+PGNpcmNsZSByPScuNScvPjxjaXJjbGUgY3g9JzMnIHI9Jy41Jy8+PGNpcmNsZSBjeT0nMycgcj0nLjUnLz48Y2lyY2xlIGN4PSczJyBjeT0nMycgcj0nLjUnLz48L3N2Zz4=);background-repeat: no-repeat;background-position: 98% 50%;    background-size: calc(.75em + .375rem) calc(.75em + .375rem);",

          "#fields-card-number.is-invalid ~ span.logo": "right: 28px",

          "#fields-card-number.is-valid ~ span.logo": "right: 28px",

          ".form-control.is-valid.is-pristine":
            "background-image: inherit; border-color:#CFCFCF;",
        };

        break;

      case "sample3":
        style_design = {
          ".form-control":
            "background-color: transparent;color: #fff;border-radius: 8px;border:none",

          ".form-control::-webkit-input-placeholder": "color:#becff2",

          ".form-control::-moz-placeholder": "color:#becff2",

          ".form-control:-ms-input-placeholder": "color:#becff2",

          ".form-control.input-verificationcode": "text-align: right",

          ".form-control.is-valid, .was-validated .form-control:valid":
            "border-color: #28a745;padding-right: calc(1.5em + .75rem); background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA4IDgnPjxwYXRoIGZpbGw9JyMyOGE3NDUnIGQ9J00yLjMgNi43M0wuNiA0LjUzYy0uNC0xLjA0LjQ2LTEuNCAxLjEtLjhsMS4xIDEuNCAzLjQtMy44Yy42LS42MyAxLjYtLjI3IDEuMi43bC00IDQuNmMtLjQzLjUtLjguNC0xLjEuMXonLz48L3N2Zz4=);background-repeat: no-repeat; background-position: 86% 50%; background-size: calc(.75em + .375rem) calc(.75em + .375rem);",

          ".form-control.is-invalid, .was-validated .form-control:invalid":
            "  border-color: #dc3545;    padding-right: calc(1.5em + .75rem);background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIGZpbGw9JyNkYzM1NDUnIHZpZXdCb3g9Jy0yIC0yIDcgNyc+PHBhdGggc3Ryb2tlPScjZGMzNTQ1JyBkPSdNMCAwbDMgM20wLTNMMCAzJy8+PGNpcmNsZSByPScuNScvPjxjaXJjbGUgY3g9JzMnIHI9Jy41Jy8+PGNpcmNsZSBjeT0nMycgcj0nLjUnLz48Y2lyY2xlIGN4PSczJyBjeT0nMycgcj0nLjUnLz48L3N2Zz4=);background-repeat: no-repeat;background-position: 98% 50%;    background-size: calc(.75em + .375rem) calc(.75em + .375rem);",

          ".form-control.is-valid.is-pristine":
            "background-image: inherit; border-color:#CFCFCF;",

          "#fields-expiration": "min-width: 122px;",
        };

        break;

      case "sample4":
        style_design = {
          ".form-control.is-valid, .was-validated .form-control:valid":
            "border-color: #28a745;padding-right: calc(1.5em + .75rem); background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA4IDgnPjxwYXRoIGZpbGw9JyMyOGE3NDUnIGQ9J00yLjMgNi43M0wuNiA0LjUzYy0uNC0xLjA0LjQ2LTEuNCAxLjEtLjhsMS4xIDEuNCAzLjQtMy44Yy42LS42MyAxLjYtLjI3IDEuMi43bC00IDQuNmMtLjQzLjUtLjguNC0xLjEuMXonLz48L3N2Zz4=);background-repeat: no-repeat; background-position: 92% 50%; background-size: calc(.75em + .375rem) calc(.75em + .375rem);",

          "#fields-card-number": "padding-left: 0",

          "#fields-card-number ~ span.logo": "position: absolute; left: 10px;",

          ".form-control.is-invalid, .was-validated .form-control:invalid":
            "  border-color: #dc3545;    padding-right: calc(1.5em + .75rem);background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIGZpbGw9JyNkYzM1NDUnIHZpZXdCb3g9Jy0yIC0yIDcgNyc+PHBhdGggc3Ryb2tlPScjZGMzNTQ1JyBkPSdNMCAwbDMgM20wLTNMMCAzJy8+PGNpcmNsZSByPScuNScvPjxjaXJjbGUgY3g9JzMnIHI9Jy41Jy8+PGNpcmNsZSBjeT0nMycgcj0nLjUnLz48Y2lyY2xlIGN4PSczJyBjeT0nMycgcj0nLjUnLz48L3N2Zz4=);background-repeat: no-repeat;background-position: 98% 50%;    background-size: calc(.75em + .375rem) calc(.75em + .375rem);",

          ".form-control.is-valid.is-pristine":
            "background-image: inherit; border-color:#CFCFCF;",

          "input#fields-card-number": "padding-left: .75rem;",
        };

        break;

      default:
        style_design = {};

        break;
    }
    return style_design;
  }, []);

  function initIframeCors(iframeId) {    
    let iframe = document.getElementById(iframeId);     
    iframe.setAttribute( 'crossorigin' ,'anonymous');    
    const meta = document.createElement('meta');   
    meta.setAttribute('http-equiv' , 'Cross-Origin-Opener-Policy');    
    meta.setAttribute('content' ,'same-origin-allow-popups' );    
    document.head.appendChild(meta);   
    const iframeURL = new URL(iframe.src);    
    iframeURL.searchParams.append('allowPaymentRequest' , 'true' );    
    iframe.src = iframeURL.toString();    
    iframe.setAttribute( 'allow'  , 'payment' );   
    iframe.setAttribute('sandbox' , 'allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox'
    );   
  }
  

  const initSaferPay = () => {

    SaferpayFields.init({      
      // apiKey: credit_params.apiKey,
      accessToken: credit_params.apiKey,
      url: credit_params.source_url,
      placeholders: {
        holdername: credit_params.cardHolderName,
        cardnumber: "0000 0000 0000 0000",
        expiration: credit_params.expiration,
        cvc: "000",
      },
      paymentMethods: credit_params.payment_methods,
      style: getStyledInput(),
      onSuccess: function () {
        document.querySelector(
          'input[name="radio-control-wc-payment-method-options"][value="spgw_credit_card"]'
        ).checked = true;
       
        insertHiddenFields("successCallback");
       /* const iframes = document.querySelectorAll("iframe");
        iframes.forEach((iframe) => {
          // Set the crossorigin attribute to desired value, e.g., "anonymous"
          let iframeID = iframe.getAttribute("id");
          initIframeCors(iframeID);
          //iframe.setAttribute("crossorigin", "anonymous");
        });*/
      },
      onError: function (evt) {
        const woocommerceErrorElement = document.querySelector('.woocommerce-error');
        if (!woocommerceErrorElement) {
          const errorElement = document.createElement('ul');
          errorElement.className = 'woocommerce-error';
          const strongElement = document.createElement('strong');
          strongElement.textContent = credit_params.error_message;
          errorElement.appendChild(strongElement);
          document.querySelector('form.woocommerce-checkout').insertBefore(errorElement, null);
        }

        insertHiddenFields("errorCallback");
      },

      onBlur: function (evt) { },

      onValidated: function (evt) {
         const elemIds = {
          cardnumber: "card-number-help",
          expiration: "expiration-help",
          holdername: "holder-name-help",
          cvc: "cvc-help",
        };
        inputValidationData.current = {
          ...inputValidationData.current,
          [evt.fieldType]: evt?.isValid || false,
        };

        if (elemIds[evt.fieldType]) {
          const elem = document.getElementById(elemIds[evt.fieldType]);

          if (evt.isValid) {
            elem.innerHTML = "";
            const element = document.getElementById(evt.id);
            element.setAttribute('data-isvalid', 'true');
            insertHiddenFields("validateCallback");
          } else {
            const key = evt.reason || "invalid";
              elem.innerHTML = labels[key];
          }
        }
      },

      onFocus: function (e) {
        const pictureCard = document.querySelector("#picture .card");
        if (pictureCard) {
          if (e.fieldType === "cvc") {
            pictureCard.classList.add("show-back");
            pictureCard.classList.remove("cardnumber");
            pictureCard.classList.remove("expiration");
            pictureCard.classList.add("cvc");
          } else if (e.fieldType === "cardnumber") {
            pictureCard.classList.remove("show-back");
            pictureCard.classList.add("cardnumber");
            pictureCard.classList.remove("expiration");
            pictureCard.classList.remove("cvc");
          } else if (e.fieldType === "expiration") {
            pictureCard.classList.remove("show-back");
            pictureCard.classList.remove("cardnumber");
            pictureCard.classList.add("expiration");
            pictureCard.classList.remove("cvc");
          }
        }
      },
    });
    
  };
  const insertHiddenFields = (data) => {
    let token = -1;
    const credit_form = document.querySelector("form.wc-block-checkout__form");

    if (data != "errorCallback") {
      if(credit_params.inline_style === 'sample3'){
        if (
          inputValidationData.current.cardnumber &&
          inputValidationData.current.expiration &&
          inputValidationData.current.cvc
        ) {
          token = 1;
        }
      }else if(credit_params.inline_style !== 'sample3'){
        if (
          inputValidationData.current.holdername &&
          inputValidationData.current.cardnumber &&
          inputValidationData.current.expiration &&
          inputValidationData.current.cvc
        ) {
          token = 1;
        }
      }
      
    }
    if (!document.getElementById("token")) {
      const inputElement = document.createElement("input");
      inputElement.setAttribute("type", "hidden");
      inputElement.setAttribute("id", "token");
      inputElement.setAttribute("name", "token");
      inputElement.setAttribute("value", token);
      credit_form.insertAdjacentElement("beforeend", inputElement);
    } else {
      document.getElementById("token").value = token;
      if (token == 1) {
        const elementsToHide = document.getElementsByClassName("credit_error");
        for (const element of elementsToHide) {
          element.style.display = "none";
        }
      }
    }
  };

  return (
    <>
      <div className={decodeEntities(settings.cardTheme)}>
        <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />
      </div>
      <CheckoutButton type="credit_card" />
      <AliasPopup onPaymentSetup={onPaymentSetup} emitResponse={emitResponse} credit_params={credit_params}/>
      <div dangerouslySetInnerHTML={{ __html: saveCardCleanHTML }} />{" "}
    </>
  );
};
const Icon = () => {
  const cleanIconHTML = DOMPurify.sanitize(settings.iconHtml);
  return (<div dangerouslySetInnerHTML={{ __html: cleanIconHTML }} style={{ float: "right", marginRight: "20px" }} className="credit_card_icons" />);
};
const Label = () => {
  const {popupTextTrans} = settings;
  return (
    <span style={{ width: "100%" }}>
      {label}
      <Icon />
      <Popup popupTextTrans={popupTextTrans} />
    </span>
  );
};

registerPaymentMethod({
  name: "spgw_credit_card",
  label: <Label />,
  content: <ContentComponent />,
  edit: <ContentComponent />,
  canMakePayment: (cart) => {
		if(!settings.availability) {
			return false;
		}
    if(cart.billingAddress.country == "" || (settings.allowedCountries.length == 1 && settings.allowedCountries.includes('select'))) {
			return true;
		}
		if(settings.allowedCountries.length != 0) {
			return settings.allowedCountries.includes(cart.billingAddress.country);
		}
		return true;
	},
  ariaLabel: label,
  supports: {
    features: settings.supports,
    showSavedCards: alias,
    showSaveOption: alias,
  },
});
